/* B2B page — transparent-to-opaque header flip.
   Mirrors the homepage behaviour in notice-slideshow.js: the header sits over
   the hero in white, then flips to cream + dark once the hero scrolls past the
   header group. Scoped to the B2B template; no-op everywhere else. */
(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('template-page-b2b')) return;

    var headerWrapper = document.querySelector('.header-wrapper');
    var hero = document.querySelector('.b2b__hero');
    if (!headerWrapper || !hero) return;

    if (!('IntersectionObserver' in window)) {
      headerWrapper.classList.add('b2b-header-opaque');
      return;
    }

    var observer = null;

    function observe() {
      if (observer) observer.disconnect();

      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      var offset = isNaN(hh) ? 65 : hh;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            headerWrapper.classList.toggle('b2b-header-opaque', !entry.isIntersecting);
          });
        },
        { rootMargin: '-' + offset + 'px 0px 0px 0px', threshold: 0 }
      );

      observer.observe(hero);
    }

    observe();

    /* --header-height is written by the header's ResizeObserver after the async
       stylesheets land, so re-arm the observer when it changes. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(observe).observe(headerWrapper);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* B2B enquiry form — posts to the Cloudflare relay.

   Progressive enhancement only: without JS the form still does a normal POST
   to the relay, which redirects back with ?b2b=sent. With JS the submit is
   intercepted so the visitor never leaves the page. */
(function () {
  'use strict';

  function initForm() {
    var form = document.querySelector('form[data-b2b-relay]');
    if (!form) return;

    var success = document.querySelector('[data-b2b-success]');
    var button = form.querySelector('button[type="submit"]');
    var stamp = form.querySelector('input[name="b2b_ts"]');

    /* The relay rejects anything submitted within 3s of the form rendering. */
    if (stamp) stamp.value = String(Date.now());

    /* A no-JS submit lands back here with the flag; show the same panel. */
    if (window.location.search.indexOf('b2b=sent') !== -1) {
      reveal();
      history.replaceState(null, '', window.location.pathname + '#b2b-enquiry');
    }

    function reveal() {
      if (!success) return;
      form.hidden = true;
      success.hidden = false;
      success.focus();
    }

    var errorSlot = form.querySelector('[data-b2b-error]');

    var MESSAGES = {
      rate_limited: 'Too many submissions from this connection. Try again in a minute.',
      missing_fields: 'Name and email are required.',
      invalid_email: 'That email address does not look right.',
      fallback: 'Something went wrong sending your brief. Please try again, or email us directly.',
      timeout: 'That took too long to send. Check your connection and try again, or reach us on WhatsApp.',
    };

    function showError(code) {
      if (!errorSlot) return;
      errorSlot.textContent = MESSAGES[code] || MESSAGES.fallback;
      errorSlot.hidden = false;
    }

    function clearError() {
      if (!errorSlot) return;
      errorSlot.hidden = true;
      errorSlot.textContent = '';
    }

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; /* let the browser post it the old way */
      event.preventDefault();
      clearError();

      var data = {};
      new FormData(form).forEach(function (value, key) {
        data[key] = value;
      });

      // Send the real landing URL (gclid / utm_*) instead of the static
      // canonical, so ad clicks can be matched to enquiries. If the visitor
      // navigated here from another page, fall back to the Google Ads click
      // id stored in the _gcl_aw cookie.
      data.page_url = window.location.href;
      try {
        var gcl = document.cookie.match(/(?:^|;\s*)_gcl_aw=GCL\.\d+\.([^;]+)/);
        if (gcl && data.page_url.indexOf('gclid=') === -1) {
          data.page_url += (data.page_url.indexOf('?') === -1 ? '?' : '&') + 'gclid=' + gcl[1];
        }
      } catch (e) {}

      var original = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.textContent = button.getAttribute('data-sending') || 'Sending…';
      }

      /* Without this a relay that accepts the connection and then stalls leaves
         the button disabled on "Sending…" forever. AbortController rather than
         AbortSignal.timeout: older Safari does not have the latter. */
      var controller = window.AbortController ? new AbortController() : null;
      var timedOut = false;
      var timer = controller
        ? setTimeout(function () {
            timedOut = true;
            controller.abort();
          }, 12000)
        : null;

      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return { ok: res.ok };
            })
            .then(function (body) {
              return { status: res.status, body: body || {} };
            });
        })
        .then(function (result) {
          if (result.body.ok) {
            reveal();
            return;
          }
          /* The relay answered but said no: say why, keep the visitor here. */
          showError(result.body.error);
        })
        .catch(function () {
          /* Timed out: the relay may already have the brief, so re-posting the
             form could file it twice. Say so and let the visitor decide. */
          if (timedOut) {
            showError('timeout');
            return;
          }
          /* The relay could not be reached at all: fall back to a real form
             post rather than stranding the visitor on a dead button. */
          form.removeAttribute('data-b2b-relay');
          form.submit();
        })
        .finally(function () {
          if (timer) clearTimeout(timer);
          if (button) {
            button.disabled = false;
            button.innerHTML = original;
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForm);
  } else {
    initForm();
  }

  /* Theme editor re-renders the section on every setting change, which
     replaces the form node and drops its listener. */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.b2b-page')) initForm();
  });
})();

/* B2B trusted-by band — marquee speed.

   The CSS animates; this only decides how long one loop takes, so desktop's
   single strip of ten and mobile's two rows of five travel at the same px/s.
   It also turns the marquee off when the logos already fit, which is what the
   Figma frame shows for a short list. */
(function () {
  'use strict';

  var SPEED = 46; /* px per second */

  function trackWidth(el) {
    return el ? el.getBoundingClientRect().width : 0;
  }

  function measure(wrap) {
    var strip = wrap.querySelector('.b2b__logos-rows');
    var rows = wrap.querySelectorAll('.b2b__logos-row');
    if (!strip || !rows.length) return;

    var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
    var wrapWidth = wrap.getBoundingClientRect().width;

    /* Desktop lifts the rows out with `display: contents`, so the strip is the
       thing that moves; mobile animates each row on its own. */
    var flattened = getComputedStyle(rows[0]).display === 'contents';

    if (flattened) {
      var sequence = 0;
      Array.prototype.forEach.call(rows, function (row) {
        sequence += trackWidth(row.querySelector('.b2b__logos-track')) + gap;
      });
      if (!sequence) return;

      if (sequence <= wrapWidth + 1) {
        wrap.setAttribute('data-b2b-marquee', 'off');
        return;
      }

      wrap.setAttribute('data-b2b-marquee', 'on');
      strip.style.setProperty('--b2b-marquee-duration', (sequence / SPEED).toFixed(2) + 's');
      return;
    }

    var fits = true;
    Array.prototype.forEach.call(rows, function (row) {
      var distance = trackWidth(row.querySelector('.b2b__logos-track'));
      if (!distance) return;
      distance += parseFloat(getComputedStyle(row).columnGap) || gap;
      if (distance > wrapWidth + 1) fits = false;
      row.style.setProperty('--b2b-marquee-duration', (distance / SPEED).toFixed(2) + 's');
    });

    wrap.setAttribute('data-b2b-marquee', fits ? 'off' : 'on');
  }

  function initMarquee() {
    var wraps = document.querySelectorAll('[data-b2b-marquee]');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      measure(wrap);

      /* This runs again on window load and on every theme-editor re-render, so
         bind the observers and image listeners once per node. */
      if (wrap.b2bMarqueeBound) return;
      wrap.b2bMarqueeBound = true;

      /* Logo images are lazy and the clamps are viewport-relative, so the
         widths land late and change on resize — including across the 990px
         breakpoint, where the whole layout flips. */
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(function () {
          measure(wrap);
        });
        observer.observe(wrap);
        Array.prototype.forEach.call(wrap.querySelectorAll('.b2b__logos-track'), function (track) {
          observer.observe(track);
        });
      }

      Array.prototype.forEach.call(wrap.querySelectorAll('img'), function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            measure(wrap);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }

  window.addEventListener('load', initMarquee);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.b2b__logos')) initMarquee();
  });
})();
